<template>
    <div class="upload-img">
      <div class="img-box" style="min-height: 7rem">
        <div class="uploadContent">
          <template v-for="(item, index) in uploadImgItems">
            <div class="collect-item" :key="index + item.IMG_CLS" v-if="filterImgClsArr.indexOf(item.IMG_CLS) === -1">
              <img-upload
                :upload-text="item.SHOW_COLLECT_TIP"
                :ref="'FORM_FILE_' + index"
                @tipEvent="tipEvent(item.IMG_CLS, item.IMG_CLS_NAME)"
                :upload-flag='!(item.IMG_DATA&&item.IMG_DATA.length)'
                @upload="uploadOneImg($event, item.IMG_CLS, index)"
                :title="item.IMG_CLS_NAME"
                :img-cls="item.IMG_CLS"
                :active='["0","1","4"].includes(item.REVIEW_STATUS)'
                :tip="getTip(item)"
                :isShowNav="isShowNav"
                @uploadModal="openUploadBox(index)"
              />
            </div>
          </template>
        </div>
      </div>
      <!-- 通用上传窗口 -->
      <img-upload-box
        v-if="isShowBox"
        :isShowBox="isShowBox"
        ref="imgUploadBox"
        class="imgUploadBox"
        :isQuickCollectFlag="isQuickCollectFlag"
        :clsInfo="currentClsInfo"
        @removeImg="removeImg"
        @imgValidate="imgValidate"
        @closeUploadBox="closeUploadBox"
        @uploadOk="uploadOk"
        @upload="uploadOneImg"
        @quickUpload="uploadmMutilImg"
      ></img-upload-box>
        <!-- 通用分类拖拽窗口 -->
      <drag-box
        v-if="isShowDrag"
        class="form-drag-contrainer"
        :imgClsArr="uploadImgItems"
        :filterImgClsArr="filterImgClsArr"
        @downloadOneClsImg="downloadOneClsImg"
        @imgValidate="imgValidate"
        @removeImg="removeImg"
        @confirmDragBox="confirmDragBox"
        @dragBoxEnd="dragBoxEnd"
      ></drag-box>
      <canvas style="display:none" id="canvasInput"></canvas>
    </div>

    <!-- <send-message v-if="riskUpdateFlag" :riskModel="riskUpdateFlag" @on-change="sendMsgChange"></send-message> -->
    <!-- 通用上传窗口 -->
</template>

<script>
import flowTip from "@/components/common/flowTip";
import imgTools from "./child/imgTools";
import imgUpload from "./child/upload";
import imgUploadBox from "./child/uploadBox";
import dragBox from "./child/dragBox.vue";
import OpencvQr from "opencv-qr";
import oppService from "@/service/opp-service";



// 初始化时需自行加载模型文件，模型文件请自行保存为静态文件，不可编译转换
let localUrl = window.location.href.split("#")[0];
let cvQr = new OpencvQr({
  // dw: "https://leidenglai.github.io/opencv-js-qrcode/models/detect.caffemodel",
  // sw: "https://leidenglai.github.io/opencv-js-qrcode/models/sr.caffemodel",
  dw: localUrl + "/static/opencvModels/detect.caffemodel",
  sw: localUrl + "/static/opencvModels/sr.caffemodel",
});
export default {
  data () {
    return {
      filterImgClsArr: ["070", "119", "x9999"],//不在界面显示
      isShowBox: false,//上传
      isShowDrag:false,//分类
      importantPagArr: ["XbQ"], //设置关键页的影像类别
      imgClsAndPageList:[],//取影像系统关键页的页数配置
      currentNum:0,
      currentClsInfo: {}, //当前选择的影像对象
      isloadingImg:false,
      fileUploadSize: "",
    };
  },
  components: {
    flowTip,
    imgUpload,
    imgUploadBox,
    dragBox,
    
  },
  props: ["bizData", "historyData", "oppBusiData", "uploadImgItems","maxApptStatus","isQuickCollectFlag","isDisabled","isShowNav","mergeImgClsArr"],
  mixins:[],
  async created () {

  },
  async mounted (){
    //获取非现场文件上传大小的系统参数
    this.fileUploadSize = await oppService.getSysCommonParamsFromCacheObjs("FXC_FILE_UPLOAD_SIZE") || "30";
  },
  methods: {
    getTip (item){
      if(item.REVIEW_REMARK === "通过"){
        return item.COLLECT_MUST == "1" ? "必传 " : "非必传 ";
      }
      if(item.REVIEW_REMARK){
        item.REVIEW_REMARK = item.REVIEW_REMARK.trim();
      }
      return (item.COLLECT_MUST == "1" ? "必传 " : "非必传 ") + (item.REVIEW_REMARK ?  ("-"+ item.REVIEW_REMARK) : "");
    },
    tipEvent (IMG_CLS,materialName){
      if (IMG_CLS === "X81" && materialName == "设立产品证明文件") {
        this.alert( "请上传合同首页、存续期页、投资范围页、签署页"); 
      }
    },
    async validate () {
      return true;
    },
    //打开 上传组件
    async openUploadBox (clsIndex) {
      this.clsIndex = clsIndex;
      this.currentClsInfo = this.uploadImgItems[clsIndex];
      let that = this;
      that.isShowBox = false;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在获取影像");
      let flag = await that.downloadOneClsImg(that.currentClsInfo);
      if(flag){
        that.isShowBox = true;
        that.$store.commit("UPDATE_LOADING", false);
      }
    },
    changeQuickCollectFlag (flag){
      this.$emit("update:isQuickCollectFlag", flag);
    },
    //关闭上传组件
    async closeUploadBox () {
      consoleLog("关闭上传弹窗,isQuickCollectFlag",this.isQuickCollectFlag);
      this.currentClsInfo = {};
      //关闭快速采集标记
      this.changeQuickCollectFlag(false);

      this.isShowBox = false;
      if (this.isQuickCollectFlag) {
        if(!await this.imgValidate()){
          return;
        }
        //关闭快速采集标记
        this.changeQuickCollectFlag(false);
        //如果有未识别窗口则加载分类组件
        let unknowFlag = this.uploadImgItems.some(val => {
          return val.IMG_CLS === "x9999" && val.IMG_DATA && val.IMG_DATA.length >= 1;
        });
        if(unknowFlag){
          this.openDragBox();
        }
      }
    },
    async uploadOk () {
      consoleLog("关闭上传弹窗,isQuickCollectFlag",this.isQuickCollectFlag);
      this.currentClsInfo = {};
      //关闭快速采集标记
      this.changeQuickCollectFlag(false);

      this.isShowBox = false;
      if (this.isQuickCollectFlag) {
        if(!await this.imgValidate()){
          return;
        }
        //关闭快速采集标记
        this.changeQuickCollectFlag(false);
        //打开分类
        this.openDragBox();
      }
    },
    //打开批量上传窗口
    openQuickCollect () {
      this.currentClsInfo = {
        IMG_CLS_NAME: "批量上传",
        IMG_DATA: [],
        IMG_CLS: "-1"
      };
      this.isShowBox = true;
    },
    //打开分类窗口
    async openDragBox () {
      this.$store.commit("UPDATE_LOADING", true);
      //重新获取影像数据
      let that = this;
      that.isloadingImg = true;
      that.isShowDrag = false;
      that.$emit("initPage",async function (){
        //默认加载第一个分类图片
        let flag1 = await that.downloadOneClsImg(that.uploadImgItems[0]);
        //如果有未识别窗口则加载未识别窗口的
        let imgArr2 = that.uploadImgItems.filter(val => {
          return val.IMG_CLS === "x9999";
        });
        let flag2 = true;
        if (!imgArr2.length) {
          //如果没有未识别分类，则默认添加一个
          that.addUnknowImgArr();
        } else {
          //如果有则加载未识别图片
          flag2 = await that.downloadOneClsImg(imgArr2[0]);
        }
        that.$store.commit("UPDATE_LOADING", false);
        that.isloadingImg = false;
        if(!flag2 || !flag1){
          that.alert({
            messageText: "加载图片失败，请重试",
            confirmButtonText: "重试",
            confirmedAction:()=>{
              that.openDragBox();
            }
          });
          that.isShowDrag = false;
          return false;
        }
        that.isShowDrag = true;
      });
    },
    async confirmDragBox () {
      this.isShowDrag = false;
    },
    //调整影像分类或顺序
    async dragBoxEnd (params, moveData, cb){
      let kidmSno = this.$store.state.oldBizData.KIDM_SNO;
      if(!params.OLD_IMG_CLS || !params.NEW_IMG_CLS || !params.IMG_FMT || !params.OLD_PAGE_NUM
       || !kidmSno || !params.NEW_PAGE_NUM){
        this.alert("分类失败,入参不能为空！");
        return;
      }
      params = Object.assign({
        SERVICE_CODE: "D1000637",
        B_SNO: kidmSno,
        CHANNEL: "13",
        USER_TYPE: this.$store.state.usertype,
      }, params);
      consoleLog("调整影像分类或顺序接口F0000037", params);
      this.$store.commit(this.$types.UPDATE_LOADING, "正在移动影像...");
      this.$syscfg.K_Request("F0000037", params).then(async res=>{
        if(res.Code == "0"){
          let targetImg = this.uploadImgItems.filter((v, i)=>v.IMG_CLS == params.NEW_IMG_CLS) || [];
          let oldImg = this.uploadImgItems.filter((v, i)=>v.IMG_CLS == params.OLD_IMG_CLS) || [];
          let res1 = true;
          let res2 = true;
          if(params.NEW_IMG_CLS === params.OLD_IMG_CLS){
            //同类别里移动
            if(moveData.newIndex < moveData.oldIndex){
              targetImg[0].IMG_DATA.splice(moveData.newIndex, 0, moveData.item);
              targetImg[0].IMG_DATA.splice(moveData.oldIndex+1, 1);
            }else{
              targetImg[0].IMG_DATA.splice(moveData.newIndex, 0, moveData.item);
              targetImg[0].IMG_DATA.splice(moveData.oldIndex, 1);
            }
          }else{
            //投放之后 将图片添加到新类别的数组里的下一帧，并删除原数据
            oldImg[0].IMG_DATA.splice(moveData.oldIndex, 1);
            // if(moveData.newIndex == -1){
            //   targetImg[0].IMG_DATA.splice(1, 0, moveData.item);
            // }else{
            targetImg[0].IMG_DATA.splice(moveData.newIndex, 0, moveData.item);
            // }
            res1 = await this.updatePageNums(oldImg[0]);
          }
          //更新影像类别的pagenum
          res2 = await this.updatePageNums(targetImg[0]);
          if(res1&&res2){
            cb(true);
          }else{
            this.alert("移动图片成功，获取影像失败，请刷新重试");
            cb(true);
          }
        }else{
          cb(false);
        }
      });
    },
    async updatePageNums (imgObj){
      let data = await this.downloadOneClsImg(imgObj, true, "1");
      if(data){
        //分类之后状态重置为1-已上传,清除备注
        imgObj.REVIEW_STATUS = "1";
        imgObj.REVIEW_REMARK = "";
        imgObj.IMG_SN = data.IMG_SN;
        //如果历史影像是pdf 需要回填IMG_FMT 5
        imgObj.IMG_FMT = data.IMG_FMT;
        if(data.IMG_DATA&&data.IMG_DATA.length){
          for(let i=0; i < imgObj.IMG_DATA.length; i++ ){
            let v = imgObj.IMG_DATA[i];
            let n = data.IMG_DATA[i];
            v.PAGE_NUM = n.PAGE_NUM;
          }
          imgObj.SHOW_COLLECT_TIP = "已上传";
        }
      }else{
        imgObj.IMG_SN = "";
        imgObj.IMG_DATA = [];
        imgObj.REVIEW_STATUS = "-1";
        imgObj.SHOW_COLLECT_TIP = "未上传";
      }
      return true;
    },
    clearStatus (obj) {
      obj.REVIEW_STATUS = "1";
      obj.REVIEW_REMARK = "";
    },
    //下载图片数据，创建url
    async downloadOneClsImg (imgObj, forceUpdate, filterImgSrc="0") {
      let imgCls = imgObj.IMG_CLS;
      if (imgObj.downloadFlag && !forceUpdate) {
        consoleLog("imgCls使用缓存影像", imgCls);
        return Promise.resolve(true);
      }
      if(!imgObj.IMG_CLS){
        this.alert("获取已采集影像失败，影像类别不能为空");
        consoleLog("获取已采集影像失败，影像类别不能为空",imgObj.IMG_CLS);
        return Promise.resolve(false);
      }
      let that = this;
      that.$store.commit(that.$types.UPDATE_LOADING, "正在获取影像");
      return new Promise(resolve=>{
        that.$emit("getImgSrc", imgObj.IMG_CLS, filterImgSrc, function (data){
          if(data){
            imgObj.downloadFlag = true;
          }
          if(filterImgSrc=="1"){
            that.$store.commit(that.$types.UPDATE_LOADING, false);
            //不需要更新imgsrc
            resolve(data||{});
          }else{
            if(data){
              imgObj.REVIEW_STATUS = data.REVIEW_STATUS;
              imgObj.IMG_SN = data.IMG_SN;
              imgObj.IMG_DATA = data.IMG_DATA;
              //如果历史影像是pdf 需要回填IMG_FMT 5
              imgObj.IMG_FMT = data.IMG_FMT;
            }else{
              imgObj.IMG_SN = "";
              imgObj.IMG_DATA = [];
              imgObj.REVIEW_STATUS = "-1";
            }
            that.$store.commit(that.$types.UPDATE_LOADING, false);
            resolve(true);
          }
        });
      });
    },
    async getQrCodeInfos (file, i){
      let qrcodeUrl = URL.createObjectURL(file);
      // 加载canvas中的图像
      let result = null;
      try{
        file.base64 = await this.loadImageToCanvas(qrcodeUrl, "canvasInput");
        result = await cvQr.load("canvasInput");
      }catch(err){
        consoleLog("cvQrload fail",err);
      }
      if(result === null){
        this.alert("识别异常，请重试！");
      }

      // 返回解析结果字符
      let infos = result.getInfos();
      // 清除加载图片，释放内存
      result.clear(); 
      consoleLog(`表单${i+1}识别结果${infos}`);
      // this.$store.commit(this.$types.UPDATE_LOADING,`表单${i+1}识别结果${infos}`);
      if(infos&&infos.length){
        infos=infos[0];
        file.QR_CODE = infos.split("_")[0];
        file.QR_CODE_INDEX = infos.split("_")[1];
      }else{
        file.QR_CODE = "x9999";
      }
      return true;
    },
    addUnknowImgArr () {
      this.uploadImgItems.push({
        AUTOADDFRAME: "1",
        COLLECT_MUST: "0",
        IMG_CLS: "x9999",
        IMG_FMT: "3",
        IMG_PAGE_CNT: "2",
        IMG_DATA: [],
        IMG_CLS_NAME: "未识别影像分类"
      });
    },
    async imgValidate (cb) {
      // if (this.apptStatus == 2) {
      //   this.alert("当前流水正在预审中，不允许操作！");
      //   return false;
      // }
      // if (this.apptStatus == 11) {
      //   this.alert("当前流水正在审核中，不允许操作！");
      //   return false;
      // }
      // if (this.apptStatus == 13) {
      //   this.alert("当前流水已办理完成，不允许操作！");
      //   return false;
      // }
      // if (this.apptStatus == 14) {
      //   this.alert("当前流水已作废，不允许操作！");
      //   return false;
      // }
      // if (this.apptStatus == 15) {
      //   this.alert("当前流水处于挂起状态，不允许操作！");
      //   return false;
      // }
      let apptStatusText = await this.$blMethod.getApptStatusText();
      if (this.maxApptStatus && this.apptStatus > this.maxApptStatus){
        this.alert(`当前流水状态为${apptStatusText},不允许操作！`);
        return false;
      }
      if(!this.$store.state.permission.editAuth){
        this.alert("您无权操作，请先申请权限");
        return false;
      }
      if (this.currentClsInfo.IMG_CLS === "071") {
        this.alert("代理人身份证明文件需在OCR界面上传识别!");
        return false;
      }
      if(this.$store.state.mobileLogin){
        let that = this;
        that.confirm({
          messageText:"请先在手机端完成数据采集方可继续操作!",
          confirmButtonText: "退出手机登录",
          confirmedAction:function (){
            //调用接口 退出手机登录
            that.$syscfg.K_Request("F0000080", {});
          },
          cancelButtonText: "取消",
          canceledAction: function () {
            return false;
          }
        });
        return false;
      }
      if(this.isDisabled){
        consoleLog("imgValidate页面禁用");
        this.alert("当前流水禁止编辑！");
        return false;
      }
      if (cb && typeof cb === "function") {
        cb(true);
      }
      return true;
    },

    getAllImportantConfig () {
      let reqList = [];
      this.importantPagArr.map(v => {
        reqList.push(this.dealAllowNum(v));
      });
      return Promise.all(reqList)
        .then(res => {
          // consoleLog("获取关键页配置", res);
          let impObj = {};
          res.map(obj => {
            Object.assign(impObj, obj);
          });
          return impObj;
        })
        .catch(err => {
          consoleLog("获取关键页配置失败", err.toString());
        });
    },
    //查询影像系统关键页
    async getIMGImportantPage () {
      let reqArr = [];
      //多个影像类别需要查询关键页时，需要循环
      this.importantPagArr.forEach((item, index) => {
        reqArr[index] = this.$syscfg.K_Request("F0000073", { IMG_CLS: item, USER_TYPE: this.$store.state.usertype });
      });
      await Promise.all(reqArr).then(resArr => {
        for (let i = 0, l = resArr.length; i < l; i++) {
          let res = resArr[i];
          if (res.Code == 0) {
            this.imgClsAndPageList.push({
              [res.Data[0].IMG_CLS]: res.Data[0].TPL_NUMS
            });
          }
        }
      });
    },
    //处理根据关键页设置，允许上传多少张
    async dealAllowNum (imgCls, curNum) {
      this.overImportantPageFlag = "0";
      let currentNum = curNum ? curNum : 0;
      if(!this.imgClsAndPageList.length){
        await this.getIMGImportantPage();
      }
      //找出当前影像类别的关键页数
      if (this.imgClsAndPageList.length > 0) {
        this.imgClsAndPageList.forEach((item, index) => {
          if (this.imgClsAndPageList[index][imgCls]) {
            this.tplNums = this.imgClsAndPageList[index][imgCls];
          }
        });
      }
      // //当前影像类别上传的数据 FORM_FILE--当前需要打印的影像类别数据集合
      let uploadImgArr = this.uploadImgItems.filter(val => {
        return val.IMG_CLS === imgCls;
      });
      let uploadImgList = _.get(uploadImgArr, "[0].IMG_DATA");
      //当前影像类别的数量 = 已经上传的+本次上传的
      let curImgNum = uploadImgList.length + currentNum;
      //OPPCP-20204 【非现场普通机构开户】影像上传界面非必采未采集还是提示必采
      if (this.tplNums != "" && curImgNum != 0 && Number(curImgNum) != Number(this.tplNums)) {
        this.overImportantPageFlag = "1";
      }
      if (this.tplNums == "") {
        this.alert("关键页配置不能为空，请刷新页面重新获取配置");
        throw "关键页配置不能为空，请刷新页面重新获取配置";
      }
      let res = {};
      res[imgCls] = { maxNum: this.tplNums, currentNum: uploadImgList.length };
      return res;
    },
    clearInputValue (index) {
      //显示上传组件时，清除上传组件的input，否则默认清除列表的input
      if (this.isShowBox) {
        this.$refs.imgUploadBox.$refs.formUploadModalBtn.value = "";
        //重置重拍标记
        this.$refs.imgUploadBox.reTakeIndex = -1;
      } else {
        let inputObj = this.$refs["FORM_FILE_" + index];
        if (inputObj && inputObj[0]) {
          inputObj[0].refresh();
        }
      }
    },
    loadImageToCanvas (url, cavansId) {
      let canvas = document.getElementById(cavansId);
      let ctx = canvas.getContext("2d");
      let img = new Image();
      img.crossOrigin = "anonymous";
      img.src = url;
      return new Promise(resolve=>{
        img.onload = function () {
          const { width, height } = img;
          let codeWidth =width*0.25;
          //截取右上角四分之一区域并放大2倍进行识别
          // canvas.width = width;
          // canvas.height = height;
          canvas.width = codeWidth*2;
          canvas.height = codeWidth*2;
          //ctx.drawImage(图片对象, 图像裁剪的x位置, 图像裁剪的y位置, 裁剪的宽度, 裁剪的高度, x位置, y位置, 宽度, 高度)
          //ctx.drawImage(img, 0, 0, width, height);
          ctx.drawImage(img, img.naturalWidth-codeWidth, 0, codeWidth, codeWidth,0,0,codeWidth,codeWidth);
          const dataURL = canvas.toDataURL("image/png");
          resolve(dataURL.replace("data:image/png;base64,", ""));
        };
      });
    },
    async uploadmMutilImg (files, IMG_CLS, index = this.clsIndex) {
      let maxLimit = 10;
      if (files.length > maxLimit && this.isQuickCollectFlag) {
        this.alert(`单次文件上传不能超过${maxLimit}张!`);
        this.clearInputValue(index);
        return;
      }
      for(let i=0; i<files.length; i++){
        let file = files[i];
        if (!/(JPG|JPEG|PNG)$/.test(file.type.toUpperCase())) {
          this.alert("文件类型错误:仅支持上传JPG、JPEG以及PNG格式图片!");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          this.clearInputValue(index);
          return;
        }
        this.$store.commit(this.$types.UPDATE_LOADING, `正在识别第${i+1}张表单`);
        let res = await this.getQrCodeInfos(file, i);
        consoleLog("res==",res);
      }
      this.uploadOneImg(files, IMG_CLS, index = this.clsIndex);
    },
    //公共上传逻辑
    async uploadOneImg (files, IMG_CLS, index = this.clsIndex, reTakeIndex = -1) {
      if(!this.isQuickCollectFlag && !this.isShowBox){
        this.currentClsInfo = this.uploadImgItems[index];
      }
      //开始递归上传图片
      this.$store.commit(this.$types.UPDATE_LOADING, "正在处理影像，请稍候...");
      //先校验，校验通过了才展示具体编辑页面
      if (!await this.imgValidate()) {
        this.$store.commit(this.$types.UPDATE_LOADING, false);
        return false;
      }
      // 一次性不能超过5张 批量上传模式不限制
      let maxLimit = 5;
      if (files.length > maxLimit && !this.isQuickCollectFlag) {
        this.alert(`单次文件上传不能超过${maxLimit}张!`);
        this.clearInputValue(index);
        this.$store.commit(this.$types.UPDATE_LOADING, false);
        return;
      } 
      let impPageConfig = {};
      //需要校验关键页的影像类别,新增才校验，重拍不校验
      if (this.importantPagArr && this.importantPagArr.indexOf(IMG_CLS) > -1 && !this.isQuickCollectFlag && reTakeIndex == -1) {
        await this.dealAllowNum(IMG_CLS, files.length);
        if (this.overImportantPageFlag == "1") {
          this.alert("文件只能上传" + Number(this.tplNums) + "张关键页！");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
      } else if (this.importantPagArr.length && this.isQuickCollectFlag) {
        //批量上传 需要预先查询关键页配置
        impPageConfig = await this.getAllImportantConfig();
        //需要送关键页配置，后端拦截多余页数的上传
        // fd.append("impPageConfig", JSON.stringify(impPageConfig));
      }
      // 批量上传检查第一个表单的格式即可
      let IMG_FMT = this.isQuickCollectFlag ? this.uploadImgItems[0].IMG_FMT : this.uploadImgItems[index].IMG_FMT;
      let totalSize = 0;
      let submitImgList = [];
      let imgDataList = [];
      for (let i = 0; i < files.length; i++) {
        //3：TIF格式，4：MP4格式允许通过
        if (IMG_FMT !== "3" || IMG_FMT !== "4") {
          //JPG
          if (IMG_FMT === "1" && files[i].type.toUpperCase().indexOf("JPG") === -1 && files[i].type.toUpperCase().indexOf("JPEG") === -1) {
            this.alert(files[i].name + "文件无法上传, 必须上传JPG格式的文件");
            this.$store.commit(this.$types.UPDATE_LOADING, false);
            return;
          }
        }
        // 禁止传tiff文件
        if (files[i].type.toUpperCase().indexOf("TIF") !== -1) {
          this.alert(files[i].name + "文件无法上传, 禁止传tif格式的文件");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
        if (files[i].size > parseInt(this.fileUploadSize) * 1024 * 1024) {
          this.alert(files[i].name + "文件无法上传, 请上传 " + this.fileUploadSize + "M大小以内的图片！");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
        if(!this.isQuickCollectFlag && this.mergeImgClsArr.indexOf(IMG_CLS) > -1 && !/(JPG|JPEG|PNG)$/.test(files[i].type.toUpperCase())){
          this.alert("文件类型错误:合并影像类别仅支持JPG、JPEG以及PNG格式图片!");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
        if (this.isQuickCollectFlag && !/(JPG|JPEG|PNG)$/.test(files[i].type.toUpperCase())) {
          this.alert("文件类型错误:批量上传仅支持JPG、JPEG以及PNG格式图片");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }else if (!/(JPG|JPEG|PNG|PDF)$/.test(files[i].type.toUpperCase())) {
          this.alert("文件类型错误:仅支持上传PDF、JPG、JPEG以及PNG格式图片!");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
        //OPPCP-32236 工商营业执照只能上传jpg
        if (files[i].type.toUpperCase().indexOf("PDF") !== -1 && IMG_CLS == "050") {
          this.alert("工商营业执照不支持上传PDF格式!");
          this.$store.commit(this.$types.UPDATE_LOADING, false);
          return;
        }
        let base64 = await imgTools.getImgUrlBase64Async(files[i]);
        let base64Data;
        //pdf不压缩，其他图片可以压缩
        if (base64.length > 1024 * 1024 * 2 && files[i].type.toUpperCase().indexOf("PDF") === -1) {
          base64Data = await imgTools.imageZipAsync({
            src: base64,
            type: files[i].type,
            size: 2 * 1024 * 1024
          });
          base64 = base64Data.url;
          if (base64Data.errorCode !== 0) {
            this.alert("图片转换失败"+base64Data.msg);
            this.$store.commit(this.$types.UPDATE_LOADING, false);
            throw "图片转base64失败";
          }
        }
        totalSize += files[i].size; //真实的文件大小
        let imgFmt = "3";
        if(files[i].type.toUpperCase().indexOf("PDF") !== -1){
          imgFmt = "5";
        } else if(IMG_CLS != "-1" && IMG_CLS != "x9999" ){
          //获取影像类别配置
          this.$store.commit(this.$types.UPDATE_LOADING, "获取影像类别配置，请稍候...");
          let res = await this.$commonService.getImgFmt(IMG_CLS);
          imgFmt = res || "3";
        }
        let data = {
          imgSrc: base64.replace("data:" + files[i].type + ";base64,", ""),
          IMG_CLS: IMG_CLS,
          IMG_CLS_NAME: _.get(this.currentClsInfo,"IMG_CLS_NAME") || "",
          IMG_FMT: imgFmt,
          isQuickCollectFlag: this.isQuickCollectFlag,
          impPageConfig: this.isQuickCollectFlag ? impPageConfig : {},
          needCollectClsArr: this.isQuickCollectFlag
            ? this.needFormClsArr
            : [],
        };
        if(reTakeIndex != -1){
          //重拍送pagenum
          data.PAGE_NUM = _.get(this.currentClsInfo, `IMG_DATA[${reTakeIndex}].PAGE_NUM`);
        }
        if(this.isQuickCollectFlag){
          //批量采集不支持pdf
          if(files[i].type.toUpperCase().indexOf("PDF") !== -1){
            this.alert("批量采集仅支持上传JPG、JPEG以及PNG格式图片!");
          }
          imgDataList.push({
            imgSrc: data.imgSrc,
            QR_CODE: files[i].QR_CODE,
            QR_CODE_INDEX: files[i].QR_CODE_INDEX
          });
          submitImgList = [Object.assign({}, data, {
            IMG_DATA_LIST: imgDataList
          })];
        }else{
          submitImgList.push(data);
        }
      }
      //转成base64之后,会变大三分之一; base64往nginx发也会变大三分之一
      if (totalSize > (parseInt(this.fileUploadSize)   * 1024 * 1024)) {
        this.$store.commit(this.$types.UPDATE_LOADING, false);
        this.alert("文件无法上传, 请确保上传的文件总大小在"+this.fileUploadSize+"M大小以内！");
        return;
      }
      //校验结束
      //开始递归上传图片
      this.$store.commit(this.$types.UPDATE_LOADING, "开始上传影像，请稍候...");

      let that = this;

      that.$emit("submitImg", submitImgList, function (resList){
        if(resList.length){
          // 上传成功后，修改影像状态并回填影像
          if(that.isQuickCollectFlag){
            let errorTip = [];
            resList = _.filter(resList, v=>{
              if(v.IMG_SN){
                //更新分类成功的表单状态
                let imgCls = v.IMG_CLS;
                let uploadImgArr = that.uploadImgItems.filter(val => {
                  return val.IMG_CLS === imgCls;
                });
                if(uploadImgArr&&uploadImgArr.length){
                  let uploadImg = uploadImgArr[0];
                  that.uploadLocalImgInfo(uploadImg, v.IMG_SN, [v], v.IMG_FMT || "3");
                }
              }else{
                errorTip.push(v.error_msg);
                return false;
              }
              return true;
            });
            errorTip = _.uniq(errorTip);
            if(errorTip.length){
              that.alert(errorTip.join(";"));
              consoleLog("批量上传结果报错", errorTip);
            }
            //批量上传逻辑
            if(that.currentClsInfo.IMG_DATA &&  that.currentClsInfo.IMG_DATA.length >=1){
              that.currentClsInfo.IMG_DATA = that.currentClsInfo.IMG_DATA.concat(resList);
            }else{
              that.currentClsInfo.IMG_DATA = resList;
            }
          }else{
            that.uploadLocalImgInfo(that.currentClsInfo, resList[0].IMG_SN, resList, resList[0].IMG_FMT || "3", reTakeIndex);
          }
          //清除input值
          that.clearInputValue(index);
          that.$store.commit(that.$types.UPDATE_LOADING, false);
        }
      });
    },
    //上传之后更新本地影像数据
    uploadLocalImgInfo (localImgInfo, imgSn, newImgData, imgFmt, reTakeIndex=-1){
      if(!localImgInfo.IMG_DATA){
        localImgInfo.IMG_DATA = [];
      }
      if(reTakeIndex != -1){
        //重拍替换图片
        localImgInfo.IMG_DATA.splice(reTakeIndex, 1, newImgData[0]);
      }else{
        localImgInfo.IMG_DATA = localImgInfo.IMG_DATA.concat(newImgData);
      }
      localImgInfo.IMG_SN = imgSn;
      localImgInfo.IMG_FMT = imgFmt;
      //清除备注
      localImgInfo.REVIEW_REMARK = "";
      if(localImgInfo.IMG_DATA.length){
        localImgInfo.REVIEW_STATUS = "1";
        localImgInfo.SHOW_COLLECT_TIP = "已上传";
      }else{
        localImgInfo.REVIEW_STATUS = "-1";
        localImgInfo.SHOW_COLLECT_TIP = "未上传";
      }
    },
    //公共 删除图片
    async removeImg (imgCls, imgSn, delList, successCallback) {
      //先校验，
      if (!await this.imgValidate()) {
        return false;
      }
      if(!imgCls||!imgSn||!delList.length){
        this.alert("删除失败：影像类别、编号或者影像页码不能为空！");
        return false;
      } 
      let params = {
        IMG_CLS: imgCls,
        IMG_SN: imgSn,
        delList: delList
      };
      this.$emit("removeImg", params, successCallback);
    },

  },
  computed: {
    busiCode () {
      return this.$store.state.busicode;
    },
    busiName () {
      return this.$store.state.busiName;
    },
    bsno (){
      return this.$storage.getSession(this.$definecfg.B_SNO);
    },
    apptStatus (){
      return this.$store.state.apptStatus;
    },
    needFormClsArr (){
      // 需要采集的影像类别
      return this.uploadImgItems.map(v => {
        return v.IMG_CLS;
      });
    },
 
  },
  watch: {
    currentIndex: {
      handler (index) {
      },
      immediate: true
    },
    isQuickCollectFlag (v){
      if(v){
        this.openQuickCollect();
      }
    },
    showLoading (v) {
      if (v) {
        this.myLoading({
          loadingText: "即将进入影像采集环节&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    },
  }
};
</script>

<style lang="less" scoped>
.upload-img {
  width: 100%;
  height: 100%;
  position: relative;
  .img-box{
    .uploadContent{
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 60px;
      min-height: 3rem;
      width: 100%;
      overflow-y: auto;
      .collect-item{
        padding:0 50px;
        width: 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/imageNode/upload-img.vue